import React, { PropsWithChildren } from "react"

import { styled } from "@mui/material/styles"

import { AssistiveChipType } from "./types/AssistiveChipType"

interface IProps extends PropsWithChildren {
  type?: AssistiveChipType,
  id?: string
}

export const AssistiveChip = ({ children, type = "default", ...props }: IProps) =>
  <Styled className={type}
          id={props.id}>
    {children}
  </Styled>

const Styled = styled("div")({
  width: "11rem",
  height: "3.2rem",
  background: "rgba(255, 221, 187, .63)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: ".4rem",
  lineHeight: "2rem",
  borderRadius: "20rem",
  fontWeight: 700,
  border: ".2rem solid #C3A565",

  "&.error": {
    background: "#F7BFB9",
    borderColor: "#FF0000"
  },

  "&.empty": {
    background: "#E5E5E5",
    borderColor: "#79747E"
  },

  "&.success": {
    background: "#B1DAC6",
    borderColor: "#008000"
  }
})
